import React from "react";
import * as S from "./StepsPayment.styles";
import cadastroIcon from "../../../../../../images/icons-figma/step-cadastro.svg";
import pagamentoActiveIcon from "../../../../../../images/icons-figma/step-pagamento-active.svg";
import pagamentoDisableIcon from "../../../../../../images/icons-figma/step-pagamento-disable.svg";

const StepsPayment = ({ step }) => {
  const pagamentoIcon = step >= 2 ? pagamentoActiveIcon : pagamentoDisableIcon;

  return (
    <S.StepsPaymentContainer>
      <div>
        <img className="step-icon" src={cadastroIcon} alt="" />
        <p className="completed-label">Cadastro</p>
      </div>

      <div className="line" />

      <div>
        <img className="step-icon" src={pagamentoIcon} alt="" />
        <p className={step >= 2 ? "completed-label" : "incompleted-label"}>
          Pagamento
        </p>
      </div>
    </S.StepsPaymentContainer>
  );
};

export default StepsPayment;
